import React, { useEffect, useState } from 'react';
import { Form, Input, InputNumber, Upload } from 'antd';
const { TextArea } = Input;
import {
  ArrowLeftOutlined,
  PaperClipOutlined,
  MinusCircleOutlined,
  PlusOutlined
} from '@ant-design/icons';
import Boton from '../Components/Atoms/Boton';
import currencyFormatter from '../Utils/currencyFormatter';
import { useNavigate } from 'react-router-dom';
import decodeToken from '../Utils/decodeToken.jsx';
import { Select } from 'antd';
import clienteAxios from '../Utils/clienteAxios';
import Swal from 'sweetalert2';

const NuevaSolicitud = () => {
  const [archive, setArchive] = useState(null);
  const [decodedToken, setDecodedToken] = useState(null);
  const [zone, setZone] = useState([]);
  const [centername, setCenterName] = useState('');
  const [ProductType, setProductType] = useState('');
  const [spent, setSpent] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isFileRemoved, setIsFileRemoved] = useState(false);
  const [isEventualesVisible, setIsEventualesVisible] = useState(false);
  const [withoutCompany, setWithoutCompany] = useState(false);
  const [total, setTotal] = useState(0);
  const [eventuales, setEventuales] = useState([]);
  const [companyEventual, setCompanyEventual] = useState([]);
  const [conceptoId, setConceptoId] = useState(null);
  const [form] = Form.useForm();
  const totalForm = Form.useWatch('total', form);
  const eventualesForm = Form.useWatch('users', form);
  const navigate = useNavigate();

  const changeCenter = (valor) => {
    let newSpent = spent.find((item) => item.id === valor);
    setCenterName(newSpent.center);
    let newSpent2 = spent.find((item) => item.id === valor);
    setProductType(newSpent2.spent_product_type);
  };

  useEffect(() => {
    if (localStorage.getItem('token')) {
      setDecodedToken(decodeToken(localStorage.getItem('token')));
    }
  }, []);

  useEffect(() => {
    clienteAxios
      .get(`/caja-chica/datos-solicitud`)
      .then((response) => {
        const filteredSpents = response.data.spents.filter((item) => item.status === '1');
        const sortedZone = filteredSpents
          .map((item) => ({
            value: item.id,
            label: item.concept,
            key: item.id
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setZone(sortedZone);
        setSpent(
          filteredSpents.map((item) => ({
            id: item.id,
            name: item.concept,
            center: item.center,
            spent_product_type: item.spent_product_type,
            key: item.id
          }))
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    clienteAxios
      .get(`/caja-chica/company`)
      .then((response) => {
        let data = response.data.companies;
        let filteredData = data.filter((item) => item.status === '1');
        setCompanyEventual(
          filteredData.map((item) => ({
            value: item.id,
            label: item.name
          }))
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const enviarFormulario = (values) => {
    const { company_id, spent_id, description, type, total, users } = values;
    const data = new FormData();
    const EventualsExist = isEventualesVisible && users && users.length > 0;
    if ((spent_id === 1 || spent_id === 2 || spent_id === 35 || spent_id === 36) && !archive) {
      Swal.fire({
        icon: 'warning',
        title: '¡Cuidado!',
        text: 'Debes adjuntar un archivo',
        confirmButtonText: 'Cerrar'
      });
      return;
    }
    // Si hay usuarios eventuales, validar campos
    if (EventualsExist) {
      const eventualIncomplete = users.some(
        (user) => !user.name || !user.pay || (!withoutCompany && !user.company)
      );
      if (eventualIncomplete) {
        Swal.fire({
          icon: 'error',
          title: 'Error al crear la solicitud',
          text: 'Completa todos los campos de los usuarios eventuales',
          confirmButtonText: 'Cerrar'
        });
        return;
      }
      const totalFromInput = users.reduce((acc, user) => acc + parseFloat(user.pay || 0), 0);
      data.append('total', totalFromInput);
      users.forEach((user, index) => {
        data.append(`eventuales[${index}][name]`, user.name);
        data.append(`eventuales[${index}][pay]`, user.pay);
        data.append(`eventuales[${index}][company]`, user.company);
      });
    } else {
      data.append('total', total);
    }
    if (!isFileRemoved) {
      data.append('file', archive);
    }
    data.append('company_id', company_id);
    data.append('spent_id', spent_id);
    data.append('description', description);
    data.append('type', type);
    setIsButtonDisabled(true);
    clienteAxios
      .post(`caja-chica/solicitudes-de-compra/crear`, data)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Creación de solicitud exitosa',
          showCancelButton: false,
          confirmButtonText: 'LISTO'
        }).then(() => {
          navigate('/solicitudes-gasto');
        });
      })
      .catch((error) => {
        console.error(error);
        setIsButtonDisabled(false);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: error.response.data.message,
          confirmButtonText: 'Cerrar'
        });
      });
  };

  // Estos conceptos no se pueden enviar sin archivo (se valida al enviar).
  const archivoRequerido = [1, 2, 35, 36].includes(conceptoId);
  const importe = isEventualesVisible ? total : totalForm || 0;
  const nombreConcepto = zone.find((item) => item.value === conceptoId)?.label;
  const pendiente = (texto) => <span className="nueva-pendiente">{texto}</span>;

  return (
    <Form
      form={form}
      className="bold-form nueva-form"
      onFinish={enviarFormulario}
      layout="vertical"
      encType="multipart/form-data">
      <div className="detalle-encabezado">
        <button
          type="button"
          className="detalle-volver"
          aria-label="Volver"
          onClick={() => navigate(-1)}>
          <ArrowLeftOutlined aria-hidden="true" />
        </button>
        <h1 className="detalle-titulo">Nueva solicitud</h1>
      </div>

      <div className="detalle-cuerpo">
        <div>
          <section className="detalle-seccion">
            <h2 className="detalle-seccion__titulo">Qué necesitas</h2>
            <Form.Item
              rules={[{ required: true, message: 'Selecciona un concepto!' }]}
              name="spent_id"
              label="Concepto">
              <Select
                placeholder="Selecciona el concepto"
                options={zone}
                required
                onChange={(valor) => {
                  changeCenter(valor);
                  setConceptoId(valor);
                  setIsEventualesVisible(valor === 21 || valor === 22);
                  setWithoutCompany(valor === 21);
                }}
                mode="single"
                allowClear
                showSearch
                filterOption={(inputValue, option) =>
                  option.label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
                }
              />
            </Form.Item>

            {isEventualesVisible && (
              <Form.Item required label="Eventuales">
                <Form.List name="users">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <div key={key} className="nueva-eventual">
                          <Form.Item
                            {...restField}
                            name={[name, 'name']}
                            rules={[{ required: true, message: 'Escribe el nombre del eventual' }]}>
                            <Input placeholder="Nombre" aria-label="Nombre del eventual" />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, 'company']}
                            rules={[{ required: true, message: 'Selecciona una empresa!' }]}>
                            <Select
                              placeholder="Empresa"
                              aria-label="Empresa del eventual"
                              options={companyEventual}
                              required
                              allowClear
                            />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, 'pay']}
                            rules={[
                              { required: true, message: 'Escribe un monto!' },
                              { type: 'number', min: 1, message: 'El monto debe ser mayor que 0' }
                            ]}>
                            <InputNumber
                              aria-label="Monto del eventual"
                              className="width-100"
                              formatter={(value) =>
                                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                              }
                              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                              onChange={(value) => {
                                const updatedEventuales = [...eventuales];
                                updatedEventuales[name] = value;
                                setEventuales(updatedEventuales);
                                setTotal(
                                  updatedEventuales.reduce((acc, curr) => acc + (curr || 0), 0)
                                );
                              }}
                            />
                          </Form.Item>
                          <button
                            type="button"
                            className="nueva-quitar"
                            aria-label="Quitar eventual"
                            onClick={() => {
                              remove(name);
                              const updatedEventuales = [...eventuales];
                              updatedEventuales.splice(name, 1);
                              setEventuales(updatedEventuales);
                              setTotal(
                                updatedEventuales.reduce((acc, curr) => acc + (curr || 0), 0)
                              );
                            }}>
                            <MinusCircleOutlined aria-hidden="true" />
                          </button>
                        </div>
                      ))}
                      <Boton
                        type="secondary"
                        onClick={() => add()}
                        icon={<PlusOutlined />}
                        required>
                        Agregar eventual
                      </Boton>
                    </>
                  )}
                </Form.List>
              </Form.Item>
            )}

            {!isEventualesVisible && (
              <Form.Item
                rules={[
                  { required: true, message: 'Escribe un monto!' },
                  { type: 'number', min: 1, message: 'El monto debe ser mayor que 0' }
                ]}
                name="total"
                label="Importe">
                <InputNumber
                  className="nueva-importe"
                  formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                />
              </Form.Item>
            )}
          </section>

          <section className="detalle-seccion">
            <h2 className="detalle-seccion__titulo">Detalle</h2>
            <Form.Item
              rules={[
                { required: true, message: 'Escribe una breve descripción o anexa tú link!' }
              ]}
              name="description"
              label="Descripción">
              <TextArea rows={6} showCount maxLength={500} placeholder="Escribe aquí" />
            </Form.Item>
          </section>
        </div>

        <aside className="detalle-panel nueva-resumen" aria-label="Resumen de la solicitud">
          <h2 className="detalle-seccion__titulo">Resumen</h2>
          <div>
            <div className="detalle-etiqueta">Solicitante</div>
            <div className="detalle-valor">{decodedToken?.user?.name}</div>
          </div>
          <div>
            <div className="detalle-etiqueta">Concepto</div>
            <div className="detalle-valor">
              {nombreConcepto || pendiente('Se elige en el formulario')}
            </div>
          </div>
          <div>
            <div className="detalle-etiqueta">Centro de costos</div>
            <div className="detalle-valor">
              {centername || pendiente('Se llena al elegir concepto')}
            </div>
          </div>
          <div>
            <div className="detalle-etiqueta">Categoría</div>
            <div className="detalle-valor">
              {ProductType || pendiente('Se llena al elegir concepto')}
            </div>
          </div>
          <div>
            <div className="detalle-etiqueta">Importe</div>
            <div className="detalle-importe">{currencyFormatter(importe)}</div>
            {isEventualesVisible && (
              <div className="nueva-nota">
                Suma de {eventualesForm?.length || 0}{' '}
                {eventualesForm?.length === 1 ? 'eventual' : 'eventuales'}
              </div>
            )}
          </div>
          <div className="nueva-archivo">
            <Upload
              maxCount={1}
              listType="picture"
              accept=".pdf, .jpg, .png, .jpeg, .doc, .docx, .xls, .xlsx"
              beforeUpload={(file) => {
                setArchive(file);
                setIsFileRemoved(false);
                return false;
              }}
              onRemove={() => {
                setArchive(null);
                setIsFileRemoved(true);
              }}
              multiple={false}>
              <Boton type="secondary" icon={<PaperClipOutlined />} block>
                Adjuntar archivo o imagen
              </Boton>
            </Upload>
            {archivoRequerido && (
              <div className="nueva-nota">Este concepto requiere un archivo adjunto.</div>
            )}
          </div>
          <Boton type="primary" htmlType="submit" disabled={isButtonDisabled} block>
            Generar solicitud
          </Boton>
        </aside>
      </div>
    </Form>
  );
};
export default NuevaSolicitud;
